import merge from 'lodash/merge';

export const deepMerge = merge;



// WEBPACK FOOTER //
// ./src/utils/object-utils.js